export const UPDATE_USERS_STATE = 'UPDATE_USERS_STATE';
export const USERS_AND_COLUMNS_LOADING = 'USERS_AND_COLUMNS_LOADING';
export const USERS_AND_COLUMNS_LOADED = 'USERS_AND_COLUMNS_LOADED';
export const USERS_AND_COLUMNS_LOAD_ERROR = 'USERS_AND_COLUMNS_LOAD_ERROR';
export const USERS_LOADING = 'USERS_LOADING';
export const USERS_LOADED = 'USERS_LOADED';
export const USERS_LOAD_ERROR = 'USERS_LOAD_ERROR';

//---------------------------- USER PROFILE ---------------------------

export const USER_INFO_LOADING = 'USER_INFO_LOADING';
export const USER_INFO_LOADED = 'USER_INFO_LOADED';
export const USER_INFO_LOAD_ERROR = 'USER_INFO_LOAD_ERROR';

export const USER_STATS_LOADING_START = 'USER_STATS_LOADING_START';
export const USER_STATS_LOADING_END = 'USER_STATS_LOADING_END';
export const USER_STATS_LOADED = 'USER_STATS_LOADED';

export const USER_EVENT_HISTOGRAM_LOADING = 'USER_EVENT_HISTOGRAM_LOADING';
export const USER_EVENT_HISTOGRAM_LOADED = 'USER_EVENT_HISTOGRAM_LOADED';
export const USER_EVENT_HISTOGRAM_LOAD_ERROR = 'USER_EVENT_HISTOGRAM_LOAD_ERROR';

export const CHATLOG_LIST_FILTERS_LOADED = 'CHATLOG_LIST_FILTERS_LOADED';

export const USER_CHATLOG_LIST_LOADING_START = 'USER_CHATLOG_LIST_LOADING_START';
export const USER_CHATLOG_LIST_LOADING_END = 'USER_CHATLOG_LIST_LOADING_END';
export const USER_CHATLOG_LIST_LOADED = 'USER_CHATLOG_LIST_LOADED';
export const MORE_USER_CHATLOG_LIST_LOADED = 'MORE_USER_CHATLOG_LIST_LOADED';
export const USER_CHATLOG_LIST_LOAD_ERROR = 'USER_CHATLOG_LIST_LOAD_ERROR';

export const ACTIVE_CHATLOG_DETAILS_LOADING = 'ACTIVE_CHATLOG_DETAILS_LOADING';
export const ACTIVE_CHATLOG_DETAILS_LOAD_ERROR = 'ACTIVE_CHATLOG_DETAILS_LOAD_ERROR';
export const ACTIVE_CHATLOG_DETAILS_LOADED = 'ACTIVE_CHATLOG_DETAILS_LOADED';


// WEBPACK FOOTER //
// ./src/data/redux/users_details/actiontypes.js